import React from "react";
import axios from 'axios';
import './Mobileheader.css';
import "./Search.css";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import CloseIcon from '@mui/icons-material/Close';
import ReactLoading from 'react-loading';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import Mobilemenu from '../Components/Mobilemenu';
import AuthService from '../Services/auth.service';
class Mobileheader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cat : [],loading:'',menu:[],place:[],id:[],
            srch:[],view:false,searchContent:false
           

        }
        
    };       
    async searchResult(e, keyword){
        //alert(keyword.length)
        this.setState({srch:keyword})
        if (keyword.length > 2){
            
            this.setState({loading:<ReactLoading type="bars" color="#000" height={50} width={35} /> })
            axios.get(process.env.REACT_APP_API_URL + 'api/method/ecom.api.item_search?item=' + keyword,{
                headers : {'content-type': 'application/json'}
            })
            .then(response=>{
                this.setState({loading:''})
                this.setState({menu:response.data['message']})
                console.log(response.data['message'])
                this.setState({view:true})
                this.setState({searchContent:true})
            })
        }
        else{

            this.setState({menu:[]})
            this.setState({loading:''})
            this.setState({searchContent:false})
        }
            
        
      }

    render() {
        const USR_TYPE =''
        if (typeof window !== 'undefined') {
        const USR_TYPE = localStorage.getItem("userType")
        }else{
            const USR_TYPE =''
        }
        /* let USR = []
        USR = localStorage.getItem("user") */
        /* const USR =JSON.parse(localStorage.getItem("user")); */
        const userJSON = localStorage.getItem("user");
        let USR;

        try {
            USR = JSON.parse(userJSON);
        } catch (error) {
            console.error("Error parsing user JSON:", error);
        }
        //console.log(USR.full_name)
        
        //const USR_TYPE = localStorage.getItem("userType")
        //console.log(USR_TYPE)
        return<div>

            <div className="container-fluid navigation-wrap start-style mob-off mt-5">
                <div className="col-md-12 row pm-0 mob-img-bar head-logo-center">
                    <div className="mob-mimi-logo mob-logo-center logo-trans">
                    <a href="/index"  ><img src="/assets/images/logo/footer-img.png"  alt="" width="90px" height="80px"/></a>

                        </div>
                        
                        
                </div>
            </div>

            <div className="nav-area mob-off sticky-head">
                <input type="checkbox" id="box"/>
                    <label htmlFor="box" className="btn-area"><i className="fa fa-bars"></i></label>
                    <span className="mob-space-icn">
                    
                    {(() => {
                                                if (this.props.user) {
                                                    return (<>
                    <input type="checkbox" id="user-box"/>
                    <label htmlFor="user-box" className="logo user-btn-area"><PersonIcon className="mob-small-icn my-mob-icn-clr"/></label>
                        
                    <ul className="mob-nav">
                
                        <li className="mb-4 off-hover "><input type="checkbox" id="user-box"/>
                        <PersonIcon className="float-left moblog-user-name-icn"/><span className="mob-log-user" >{USR.full_name}</span>
                       <label for="user-box" className="btn-area float-right close-icn-align"><CloseIcon/></label></li><hr className="mob-log-uline"/>
                        

                        <li><a href="/my-profile">My Profile</a></li>
                        <li><a href="/my-orders">My Orders</a></li>
                        {USR_TYPE === 'agent' ? <> <li><a href="/agent-dashboard">Dashboard</a></li> <li><a href="/agent-sales">Customer Orders</a></li> </>  : ''}
                        <li><a href="#" htmlFor="user-box" onClick={this.props.logout}>Log Out</a></li>
                    </ul>
                    </>)    
                                                  } 
                                                else {
                                                return (<>
<input type="checkbox" id="user-box"/>
                    <label onClick={this.props.login} className="logo user-btn-area"><PersonIcon className="my-mob-icn-clr"/></label>
</>)
                                                     }
                                            })()}
                    <label className="logo"><a href="/cart"><ShoppingCartIcon className="mob-small-icn my-mob-icn-clr"/></a></label>
                    <label className="logo"/*onClick={this.loc_large}*/><a href="#" className ="my-mob-icn-clr" onClick={this.props.Location}><LocationOnIcon className="mob-small-icn my-mob-icn-clr"/><span className="location-span">{this.props.place}</span></a></label>
                    </span>
                    
                    <Mobilemenu/>
                     

            </div>
            
            <div className="mob-off mb-2 mt-2">
                <div className="input-group filter-by search-box mob-ser-box">
                        <input type="text" className="rounded-lg mob-srch-txt" name="x" /*  onBlur={(e) => {this.setState({searchContent:false})}}  */  onChange={e => this.searchResult(e, e.target.value)} placeholder="Search for products"  />
                        <span className="input-group-addon search-pad">
                            <a href={'/search/'+this.state.srch}><SearchOutlinedIcon className="fa fa-search icon-position srch-icn" type=""/></a>
                        </span>
                        <div className={this.state.searchContent ? 'search_box_content d-block' : 'd-none'}    >
                            {this.state.loading}
                            {this.state.menu.map((itm,p)=>{
                                 if(p < 4){
                                return(<div className={"row row" + p}  onClick={(e) => {this.setState({searchContent:true})}}>
                                            <div className="col-3 float-left srch-width mt-2 "><a href={ '/product-details/' + itm.item_code }><img alt={itm.item_name} src={( itm.website_image )? process.env.REACT_APP_API_URL +itm.website_image:'/assets/images/missing.jpg'} style={{maxHeight: 75}} width="50px"/></a></div>
                                            
                                            <div className="col-6 text-left  ml-2 my-auto float left none-width "><a href={  '/product-details/' + itm.item_code }><span className="my-auto srch-text srch-result-itm">{itm.item_name}</span></a></div>
                                            
                                               <div className="text-left  ml-5 my-auto col-3"><a href={  '/product-details/' + itm.item_code }><span className="my-auto mob-rs-space srch-result-itm rupay-font"> 
                                               ₹ {itm.price}</span></a></div> 
                                    </div>)
                                 }
                                 else
                                 return ""
                            })}  
                        {this.state.menu.length ?<div> <p className="srch-result-align " type="button" ><a href={'/search/' + this.state.srch } className="float-left srch-result-clr">{this.state.menu.length} Results Found</a><a href={'/search/' + this.state.srch } className="float-right srch-result-clr">View All</a></p></div> : '' }            
          
                    </div>
                </div>
            </div>
    </div>
    
    }
}

export default Mobileheader;